<template>
  <div>
    <div class="container">
      <CommonPromo
        placement="full"
        header1="HereArePortals"
        header2="HereArePortals2"
      />
      <LayoutGrid>
        <PaperTeaser
          v-for="(paper, index) in papers"
          :key="index"
          :paper="paper"
          type="default"
        />
      </LayoutGrid>
      <AdsConceptAd
        v-if="isSite('altinget_se')"
        class="lg:hidden"
        id="altinget-mob2"
      />
    </div>
    <LayoutStaticPageBottom :paper="1" />
  </div>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp()
useHead({
  title: nuxtApp.$t('Papers'),
})

const indexStore = useIndexStore()
const papers = computed(() =>
  indexStore.papers.filter(
    (paper) => paper.RecordId !== 1 && paper.Status !== 0
  )
)
</script>
